/**
 * 全局事件通信总线
 * 作用：可以让任何组件之间相互通信
 */
import Vue from 'vue'

export default new Vue()
